import React from 'react';
import { TableRow } from '@mui/material';
import { FormDateInput } from '~/components/FormComponents/FormDateInput.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { FinancialConditionTableCell } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTableCell.tsx';
import { FinancialConditionTableDeleteCell } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTableDeleteCell.tsx';
import type { IReceivableRowProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/receivables/types.ts';
import { normalizeDecimalValue } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';
import { financialConditionTableFieldStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/styles.ts';

export const ReceivableRow: React.FC<IReceivableRowProps> = ({
  index,
  canRemove,
  disabled,
  onRemove,
}) => (
  <TableRow>
    <FinancialConditionTableCell>
      <FormInput
        name={`receivables.${index}.counterpartyName`}
        label="Найменування контрагента"
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`receivables.${index}.edrpou`}
        label="ЄДРПОУ"
        type="text"
        inputProps={{ inputMode: 'numeric' }}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`receivables.${index}.subject`}
        label="Предмет заборгованості"
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`receivables.${index}.totalDebt`}
        label="Загальна заборгованість, тис. од."
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizeDecimalValue}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`receivables.${index}.overdueAmount`}
        label="Прострочена заборгованість, тис. од."
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizeDecimalValue}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormDateInput
        name={`receivables.${index}.originDate`}
        label="Дата виникнення"
        disabled={disabled}
        sx={financialConditionTableFieldStyles.dateField}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormDateInput
        name={`receivables.${index}.repaymentDate`}
        label="Дата погашення"
        disabled={disabled}
        sx={financialConditionTableFieldStyles.dateField}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableDeleteCell
      label={`Видалити дебіторську заборгованість ${index + 1}`}
      disabled={disabled}
      hidden={!canRemove}
      onDelete={onRemove}
    />
  </TableRow>
);
